import CloseIcon from "@mui/icons-material/Close";
import { Drawer, Grid, IconButton, useTheme } from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import AddOrSelectClient from "./AddORSelectClient";
import SelectService from "./SelectService";
import SelectedClientDetails from "./SelectedClient";
import CreateNewAppointment from "./CreateNewAppointment";

const drawerComponentStyle = {
  "& .MuiDrawer-paper": {
    width: { xs: "100%", md: "55%", xl: "40%" },
  },
  "& .MuiDrawer-paper .drawer-close-icon": {
    position: "fixed",
    top: 16,
    left: "40%",
    zIndex: 1300,
    backgroundColor: "custom.white",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  },
};

const AddEditAppointment = forwardRef(({ selectedEvent }, ref) => {
  const { palette } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  // Redux states
  const { selectedClient } = useSelector(
    (state) => state.selectedClientReducer
  );
  const { selectionType } = useSelector((state) => state.selectionTypeReducer);

  // Use useImperativeHandle to expose open/close methods to parent components
  useImperativeHandle(ref, () => ({
    openDrawer: () => setIsOpen(true),
    closeDrawer: () => setIsOpen(false),
  }));

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      sx={{ ...drawerComponentStyle }}
    >
      <IconButton
        className="drawer-close-icon"
        onClick={() => setIsOpen(false)}
      >
        <CloseIcon />
      </IconButton>
      <Grid container height="100vh">
        <Grid item xs={12} md={4}>
          {selectedClient === null ? (
            <AddOrSelectClient />
          ) : (
            <SelectedClientDetails />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          sx={{ borderLeft: { md: `1px solid ${palette.primary.main}` } }}
        >
          {selectionType == "add_service" ? (
            <SelectService />
          ) : (
            <CreateNewAppointment setIsOpen={setIsOpen} />
          )}
        </Grid>
      </Grid>
    </Drawer>
  );
});

export default AddEditAppointment;
